module.exports = __webpack_public_path__ + "static/media/bookr_mac.aa4fd541.png";